import { MapQueryService } from '../../map-query.service';
import { pdfMake } from 'pdfmake/build/pdfmake';
import { AfterViewInit, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import {Location} from '@angular/common';
import Map from 'ol/Map';
import Feature from 'ol/Feature';
import View from 'ol/View';
import {Point,Polygon,MultiPoint} from 'ol/geom';
import {Style,Fill, Stroke,Circle} from 'ol/style';
import {Draw, Modify, Snap} from 'ol/interaction';
import Icon from 'ol/style/Icon';
import OSM from 'ol/source/OSM';
import WMTS from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import Overlay from 'ol/Overlay';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import LayerSwitcher from 'ol-layerswitcher';
import * as shpwrite from '@aleffabricio/shp-write';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';
import Attribution from 'ol/control/Attribution';
import { Field, ReportsService, SystemService } from '../../apiclient';
import { UserSessionService } from '../../UserSession/user-session.service';
import * as olEventsCondition from 'ol/events/condition';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Componente que renderiza el editor de geometrías
 */
@Component({
  selector: 'ngx-field-editor',
  templateUrl: './field-editor.component.html',
  styleUrls: ['./field-editor.component.scss']
})
export class FieldEditorComponent implements OnInit,AfterViewInit {
  @ViewChild('deleteconfirmation')
  private deleteconfirmationTpl: TemplateRef<any>;

  config: any;
  map: Map;
  feature: Feature;

  parcelasSource: VectorSource;
  featureoriginal: Feature;
  loading: boolean = false;
  loadingMessage: string = "";
  parcela: any = {};
  regions: string[] = [];
  filteredRegions$: Observable<string[]>;
  crearParcelaInteraction: any;
  busquedaLocalidad: string;
  @ViewChild("parcelaname") parcelafield: ElementRef;
  @ViewChild("mapa") mapadiv: ElementRef;
  parcelaStyle =  new Style({
    stroke: new Stroke({
      color: 'blue',
      width: 1,
    }),
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.1)',
    }),
  });

  verticesStyle = new Style({
    image: new Circle({
      radius: 8,
      fill: new Fill({
        color: 'orange',
      })
    }),
    geometry: function (feature) {
      // return the coordinates of the first ring of the polygon
      var coordinates = feature.getGeometry().getCoordinates()[0];
      return new MultiPoint(coordinates);
    },
  });

  constructor(private location: Location,
    private userSessionService: UserSessionService,
    private systemService: SystemService,
    private toastrService: NbToastrService,
    private route: ActivatedRoute,
    private dialogService: NbDialogService,
    private mapQueryService: MapQueryService) { }

    /**
     * @ignore
     */
  ngOnInit(): void {


      this.config = {
        target: 'visormap',
        center : [0,0]
      };




  }


  /**
   * Inicializa el mapa Openlayers
   */
  initMap() {
    this.mapadiv.nativeElement.innerHTML = "";
    console.log("INIT MAP")

    this.parcelasSource = new VectorSource();
    const attribution = new Attribution({
      html: 'Teselas de PNOA cedido por � Instituto Geogr�fico Nacional de Espa�a'
    });

    let projection = olProj.get('EPSG:3857');
    let projectionExtent = projection.getExtent();
    //var size = ol.extent.getWidth(projectionExtent) / 512;
    let size = olExtent.getWidth(projectionExtent) / 256;
    let resolutions = new Array(18);
    let matrixIds = new Array(18);
    for (var z = 0; z < 18; ++z) {
      // generate resolutions and matrixIds arrays for this WMTS
      resolutions[z] = size / Math.pow(2, z);
      //matrixIds[z] = "EPSG:4326:" + z;
      matrixIds[z] = z;
    }

    this.map = new Map({
      target: this.config.target,
      layers: [
        new TileLayer({
          source: new OSM(),
          visible:true,
          title: 'Mapa Base',
          type:'base',
        }) ,
        new TileLayer({
          visible:false,
          title: 'Mapa PNOA',
          type:'base',
          source: new WMTS({
            attributions: ['<a href="httpS://www.ign.es" target="_blank">IGN</a>'],
            url: 'http://www.ign.es/wmts/pnoa-ma',
            layer: 'OI.OrthoimageCoverage',
            // matrixSet: 'EPSG:4326',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: olProj.get('EPSG:3857'),
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds
            }),
            style: [this.parcelaStyle,this.verticesStyle]
          })
        }),
        new TileLayer({
          visible: false,
          title: 'Mapa Geográfico',
          type:'base',
          source: new WMTS({
            attributions:
              'Tiles © <a href="https://services.arcgisonline.com/arcgis/rest/' +
              'services/Demographics/USA_Population_Density/MapServer/">ArcGIS</a>',
            url:
              'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/WMTS/',
            layer: '0',
            matrixSet: 'EPSG:3857',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
              origin: olExtent.getTopLeft(olProj.get('EPSG:3857').getExtent()),
              resolutions: resolutions,
              matrixIds: matrixIds,
            }),
            style: 'default',
            wrapX: true,
          }),
        }),
        new VectorLayer({
          source: this.parcelasSource,
        }),

      ],
      view: new View({
        center: olProj.fromLonLat(this.config.center),
        zoom: 5,
      })
    });

    var modif =  new Modify({
      source: this.parcelasSource,
      // the SHIFT key must be pressed to delete vertices, so
      // that new vertices can be drawn at the same position
      // of existing vertices
      deleteCondition: function(event) {
        return olEventsCondition.shiftKeyOnly(event) &&
        olEventsCondition.singleClick(event);
      }
    });
    modif.on('modifyend', evt => {

    });
    this.map.addInteraction(modif);
      console.log("Inicializado el mapa")
      if(typeof this.crearParcelaInteraction != 'undefined'){
        this.map.addInteraction(this.crearParcelaInteraction)
      }else{

      }
      var layerSwitcher = new LayerSwitcher();
      this.map.addControl(layerSwitcher);

  }

  /**
   * Activa el modo creación de geometría
   */
  crearParcela(): void {
    console.log("Invocada crear parcela")
    this.crearParcelaInteraction = new Draw({
      source:this.parcelasSource,
      type: 'Polygon',
    })

    this.map.addInteraction(this.crearParcelaInteraction);
    this.map.addInteraction(new Snap({source:this.parcelasSource}));
    console.log("Añadida interaccion de crear parcela")
    setTimeout(()=> {
      console.log("Centrando el mapa")
      this.map.getView().setCenter([0.1,0.1]);
      this.map.getView().setZoom(1);
      this.map.updateSize();
    },200)
  }

  /**
   * Dibuja una geometría en el mapa
   * @param field Geometría
   */
  pintarParcela(field: any): void{
    if(field.polygon != null) {

      console.log(field.polygon)

      if( field.polygon.type == 'Polygon'){
        field.polygon.coordinates[0] = field.polygon.coordinates[0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })
      }else if(field.polygon.type == 'MultiPolygon'){
        field.polygon.coordinates[0] = field.polygon.coordinates[0][0].map(function(coordinate){
          return olProj.fromLonLat(coordinate);
        })
      }

      console.log(field.polygon)
      let feature = new Feature({
        geometry: new Polygon(
          field.polygon.coordinates),

        parcela: {name:field.name,region:field.region},
      });

      feature.setStyle([this.parcelaStyle,this.verticesStyle]);

      this.parcelasSource.addFeature(feature);
      console.log("Fitting");
      console.log(feature.getGeometry().getExtent());
      this.map.getView().fit(feature.getGeometry().getExtent(),{padding:[100,100,100,100],nearest:true});
      //this.map.getView().setZoom(16);
      setTimeout(()=> {
        this.map.updateSize();
      },200)

    }else{
      setTimeout(()=> {
        console.log("Centrando el mapa")
        this.map.getView().setCenter([0.1,0.1]);
        this.map.getView().setZoom(1);
        this.map.updateSize();
      },200)
    }


  }


  /**
   * Inicializa el componente
   */
  initUI(): void {
    this.initMap();
      this.route.paramMap.subscribe((params) => {
        let p = params.get('idParcela');
            console.log("Editando parcela "+p);

            this.userSessionService.getCachedRegionsList().subscribe((regions) => {
              this.regions = regions;
              this.filteredRegions$ = of(this.regions);
            })






                if (p != '0'){
                  this.userSessionService.getCachedFieldList().subscribe((parcelas) => {
                  this.parcela = JSON.parse(JSON.stringify(parcelas.find(parc => parc.id == +p))) ;

                  if ( null != this.parcela.polygon){
                    this.pintarParcela(this.parcela);
                    setTimeout(()=> {
                      this.parcelafield.nativeElement.focus();
                    },500)
                  }else{
                    this.crearParcela();
                  }

                  });



                }else{
                  this.parcela.id = 0;
                  console.log("Añadiendo la opcion de parcela")
                  this.crearParcela();
                }
                this.loading = false;





        });
  }

  /**
   * @ignore
   */
  ngAfterViewInit(): void {



      this.loadingMessage = "Espere un momento..."

      this.loading = true;
      setTimeout(()=> {
        this.initUI();
      },500)



  }

  /**
   * Regresa a la página anterior
   */
  back(): void{
    this.location.back()
  }

  /**
   * Guarda la geometria
   * @returns
   */
  guardar(): void{

    if(this.parcela.name == null){
      this.toastrService.danger("El campo nombre es obligatorio",'Error al guardar');
      return;
    }


    this.loadingMessage = "Guardando parcela..."
    this.loading = true;

    if(this.parcelasSource.getFeatures().length > 0){
      console.log(this.parcelasSource.getFeatures()[0].getGeometry())
      var geojson = new GeoJSON();

      var geopolygon = JSON.parse(geojson.writeGeometry(this.parcelasSource.getFeatures()[0].getGeometry()))
      console.log(geopolygon);
      geopolygon.coordinates[0] = geopolygon.coordinates[0].map(function(coordinate){
        return olProj.toLonLat(coordinate);
      })
      console.log(geopolygon);


      this.parcela.polygon = geopolygon;
    }else{
      delete this.parcela.polygon;
    }

    console.log(this.parcela)

    if(this.parcela.id == '0'){
        delete this.parcela.id;
        this.systemService.createField(this.parcela,this.userSessionService.accessToken).subscribe((parcela)=> {
          console.log(parcela)
          this.confirmarParcelaGuardada();


        })
    }else{
      this.systemService.updateField(this.parcela,this.userSessionService.accessToken).subscribe((parcela)=> {
        console.log(parcela)
        this.confirmarParcelaGuardada();

      })
    }
    console.log(geopolygon);

  }

  /**
   * Muestra la confirmación de geometría guardada
   */
  confirmarParcelaGuardada(): void {

    this.userSessionService.removeCachedFieldList();

      this.loading = false;
      this.toastrService.success('Se ha guardado la parcela correctamente','Parcela guardada');
      this.back();


  }

  /**
   * Elimina una geometría mediante la aparición de un diálogo de confirmación
   */
  eliminar(): void{
    this.dialogService.open(this.deleteconfirmationTpl);
  }

  /**
   * Confirma la eliminación de una geometría
   */
  confirmarEliminar(): void{

    this.parcela.disabledAt = new Date();
    this.guardar();
  }

  /**
   * Busca localidad en el mapa
   */
  buscarLocalidad(): void{
    this.loadingMessage = "Buscando localidad..."
    this.loading = true;
    console.log("Buscamos la localdiad")
    this.mapQueryService.queryLocationByAddress(this.busquedaLocalidad).then((locat)=>{
      console.log(locat);
      this.loading = false;
      this.map.setView(new View({
        center: olProj.fromLonLat([locat.lng,locat.lat]),
        zoom: 17,
      }));
    });
  }
}
